



























import { Component, Vue } from "@/shared/vuepack";

import Terms from "@/employee/components/onboarding/Terms.vue";
import { useThemeStore } from "@/shared/store/theme";
import { UserTermsType } from "@/shared/types";
import { useLoginPromptOrchestratorStore } from "@/employee/store/LoginPromptOrchestrator";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useImpersonatorStore } from "@/shared/store/impersonator";

@Component({
  components: {
    Terms,
  }
})
export default class TermsModal extends Vue {
  themeStore = useThemeStore();
  loginPromptOrchestratorStore = useLoginPromptOrchestratorStore();
  hsabAccountsStore = useHsabAccountsStore();
  impersonatorStore = useImpersonatorStore();
  UserTermsType = UserTermsType;

  get showModal () {
    return this.loginPromptOrchestratorStore.isTermsSignatureRequired;
  }

  onComplete () {
    this.loginPromptOrchestratorStore.dismissTerms();
  }

  get userHasHsaAccount () {
    return this.hsabAccountsStore.userHasHsaAccount;
  }
  get showFeeSchedule (): boolean {
    return !this.hsabAccountsStore.isNotionalOnly;
  }

  onHidden () {
    // do the thing
  }
  get isImpersonating (): boolean {
    return this.impersonatorStore.isActive;
  }
  close () {
    this.loginPromptOrchestratorStore.dismissTerms();
  }
}
